import React from 'react';

import {Dialog} from '../../../../base/dialog/dialog';
import {blurAfterPointer} from '../../../../../helpers/focus';
import {switchEnvironment} from '../../../../../helpers/auth-helper';
import {useTranslation} from '../../../../../hooks/use-translation';

interface props {
    onRequestClose(): void;
}

/** Before the terminal switches to the test API (development): it shows no production data there. */
export const EnvironmentAlertModal = (props: props): React.JSX.Element => {
    const t = useTranslation();

    const switchToDevelopment = (event: React.MouseEvent<HTMLButtonElement>): void => {
        blurAfterPointer(event);
        switchEnvironment('development');
        props.onRequestClose();
    };

    return (
        <Dialog
            title={t('environment.title')}
            onRequestClose={props.onRequestClose}
            footer={
                <>
                    <button type="button" className="button" onClick={props.onRequestClose}>
                        {t('environment.cancel')}
                    </button>
                    <button type="button" className="button button-danger" onClick={switchToDevelopment}>
                        {t('environment.switch')}
                    </button>
                </>
            }
        >
            <p>{t('environment.warning')}</p>
        </Dialog>
    );
};
